import ApiHttpService from '../api/api-http-service';
/**
 * HTTP push handler for async-client-manager library
 * This function matches the contract expected by the pushHttp method
 *
 * @param {object} params - Push parameters from async-client-manager
 * @param {string} params.channel - Pusher channel name
 * @param {string} params.eventName - Event name to trigger
 * @param {object} params.message - Message payload
 * @param {Array} params.clientPusherApps - Array of {key, socketId} objects
 * @returns {Promise} - Resolves when message is sent
 */
export const onHttpPush = async ({
  channel,
  eventName,
  message,
  clientPusherApps
}) => {
  try {
    // Prepare the request payload
    const payload = {
      channel,
      eventName,
      message,
      clientPusherApps
    };

    console.debug('Sending HTTP pusher message:', {
      channel,
      eventName,
      hasActionId: !!payload.actionId,
      clientPusherAppsCount: (clientPusherApps && clientPusherApps.length) || 0
    });

    // Send the HTTP request to WebApi via ApiHttpService
    // Note: ApiHttpService.post returns the data directly, not the full response
    await ApiHttpService.post('notifier/send', payload);

    console.debug(`HTTP pusher message sent successfully: ${eventName}`);
  } catch (error) {
    console.error('Error sending HTTP pusher message:', {
      channel,
      eventName,
      error: error.message,
      status: error.response?.status,
      data: error.response?.data
    });

    // Re-throw so async-client-manager can handle fallback
    throw error;
  }
};
